import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledHeading = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		line-height: 120%;
		color: #ffffff;
	}
`;

const StyledStepText = styled(Text)`
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;

	span {
		opacity: 0.5;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	margin-top: 30px;
	background-color: rgba(217, 217, 217, 0.1);
`;

export { StyledContainer, StyledHeading, StyledStepText, StyledDivider };
